import { Icon, IconName } from '@ardoq/icons';
import { classes } from '@ardoq/common-helpers';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { hideRightPane } from 'appContainer/actions';
import { referenceFab$ } from './referenceFab$';
import { activateReferenceFab } from './actions';
import { FabContainer } from '../atoms';
import { FabColor } from '../types';
import { FAB_SIZE } from '../consts';
import { type I18nLocale, t } from '@ardoq/i18n';

type ReferenceFabProps = {
  readonly isVisible: boolean;
  readonly isActive: boolean;
  readonly i18nLocale: I18nLocale;
};

const ReferenceFabBase = ({
  isVisible,
  isActive,
  i18nLocale,
}: ReferenceFabProps) => {
  if (!isVisible) {
    return null;
  }
  const label = isActive
    ? t(i18nLocale, 'views:fab.referenceFab.closeSidebar', 'Close sidebar')
    : t(i18nLocale, 'views:fab.referenceFab.create', 'Create a reference');
  return (
    <FabContainer
      className={classes(isActive && 'active')}
      color={FabColor.RED}
      $rightOffset={FAB_SIZE + FAB_SIZE / 4}
      onClick={() => {
        if (isActive) {
          return dispatchAction(hideRightPane());
        }
        dispatchAction(activateReferenceFab());
      }}
      aria-label={label}
      data-tooltip-text={label}
    >
      <div className="fab-main">
        <Icon iconName={IconName.CLOSE} />
      </div>
    </FabContainer>
  );
};

export const ReferenceFab = connect(ReferenceFabBase, referenceFab$);
